import React, { useState } from "react"
import {
  Container,
  Button,
  Row,
  Col,
  FormGroup,
  Input,
  Alert,
} from 'design-react-kit';

import * as Validator from "../../../utils/validator"
import getBrowserName from "../../common/GetBrowserName";

export const SibaInputScadenzaValidita = ({ __handleScadenzaChange, __handleValiditaChange, handleNonPagabileChange }) => {

  const [scadenza, setScadenza] = useState('');
  const [validita, setValidita] = useState('12');
 
  const onScadenzaChanged = (event) => {
    console.log('scadenza:', event.target.value)
    setScadenza(event.target.value);
    __handleScadenzaChange(Validator.getValidScadenzaOrEmptyValue(event.target.value));
  }

  const onValiditaChanged = (event) => {
    setValidita(event.target.value);
    __handleValiditaChange(Validator.isValidNumber(event.target.value) ? event.target.value : '');
  }

  const isButtonDisabled = () => {
    //STALIGK-833  return !Validator.isValidScadenza(scadenza) || !Validator.isValidNumber(validita);
    // STALIGK-909
    if (isScadenzaPagabile()) {
        return false;
      } else {
        return true;
      }
    }

   const DivNonPagabileVisibile = () => {
      if (isScadenzaPagabile()) {
        return false;
      } else {
        return true;
      }
    }

  const isScadenzaPagabile = () => {
    let isValid = (Validator.isValidScadenza(scadenza) && Validator.isMesiValidità(validita));
    if (isValid === true)  { //controllo scadenza pagabile in base alla sysdate
        let dataOdierna = new Date();
        console.log("scadenza2:" + scadenza);
        let dataScadenza = new Date(scadenza);
        console.log("dataOdierna:" +  dataOdierna + " - dataScadenza:" + dataScadenza);
        let primoGiorno = new Date(dataScadenza.setMonth(dataScadenza.getMonth() - (validita - 1)));
        console.log("primoGiornoPagabile:" + primoGiorno); 
        if (dataOdierna < primoGiorno) { 
          isValid = false;
        }
    }
    console.log("isValid:" + isValid);
    return isValid;
  }  

  // *** nuovi metodi x STALIGK-833 ***
  const browser = getBrowserName();

  const ScadenzaInputType = () => {
        console.log(browser);
     if ((browser === "Firefox") || (browser === "Safari")) 
        return "text";
    else 
        return "month";    
  }

  const ScadenzaPlaceHolder = () => {
    if ((browser === "Firefox") || (browser === "Safari")) 
        return "Scadenza in formato AAAA-MM";
    else 
        return "Scadenza in formato nome mese - anno";    
  }
  const ScadenzaInfoText = () => {
    if ((browser === "Firefox") || (browser === "Safari")) 
        return "Digitare anno e mese in cui termina la validità (formato AAAA-MM)";
    else 
        return "Selezionare dal calendario mese e anno in cui termina la validità";    
  }

  function format(inputDate) {
    let date, month, year;
    date = inputDate.getDate();
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();
     date = date
          .toString()
          .padStart(2, '0');
      month = month
          .toString()
          .padStart(2, '0');
    return `${date}/${month}/${year}`;
  }

  function drawAlert() {
    //if (DivNonPagabileVisibile() && scadenza !== '' && Validator.isMesiValidità(validita)) {
    if (DivNonPagabileVisibile() && Validator.isValidAnnoMeseScadenza(scadenza,ScadenzaInputType()) && Validator.isMesiValidità(validita)) {
        let dataScadenza = (scadenza !== '' && scadenza !== undefined ? new Date(scadenza) : '');
      let primoGiorno = (dataScadenza !== '' ? new Date(dataScadenza.setMonth(dataScadenza.getMonth() - (validita - 1))) : '');
      console.log("SCADENZA E PRIMO GIORNO: ",scadenza,primoGiorno );
      let primoGiornoStr = (primoGiorno !== '' ? format(primoGiorno) : '');
      return (<Alert color="warning">Non è possibile ancora effettuare il pagamento per la scadenza inserita !<br/>
      <em>Primo giorno utile per il pagamento : <strong>{primoGiornoStr} </strong></em></Alert>)
    } else {
      return (<></>)
    }
  }
  //START RENDERING
  return (
    <Container className="px-2 my-2" id="scadenzaVeicolo" tag="section" >
      <h3>Ulteriori dati necessari</h3>
      <Container className="my-4" id="scadenzaVeicolo1" tag="section" >
        <Row>
          <Col md={6}>
            <FormGroup className="my-2">
              <Input
                id="inserisciScadenza"
                //infoText="Anno-Mese in cui termina la validità (aaaa-mm)"
                infoText={ScadenzaInfoText()}
                label="Valido fino al"
                //placeholder="scadenza in formato aaaa-mm"
                placeholder={ScadenzaPlaceHolder()}
                value={scadenza}
                type={ScadenzaInputType()}
                //type="month"
                //pattern={ScadenzaInputPattern()}
                onChange={onScadenzaChanged}
                invalid={!Validator.isValidAnnoMeseScadenza(scadenza,ScadenzaInputType())}
                valid={Validator.isValidAnnoMeseScadenza(scadenza,ScadenzaInputType())}
              />
              </FormGroup>
           </Col>
           <Col  md={6}>
           <FormGroup className="my-2"> 
              <Input
                id="inserisciValidita"
                infoText="Numero di mesi per cui il bollo risulterà pagato (max=12)"
                label="Durata in mesi"
                placeholder=""
                value={validita}
                type="number"
                min={2}
                max={12}
                onChange={onValiditaChanged}
                invalid={!Validator.isMesiValidità(validita)}
                valid={Validator.isMesiValidità(validita)}
              />
            </FormGroup>
          </Col>
        </Row>
      </Container>
        { drawAlert() }
      <Button className="btn btn-primary" color="primary" icon={false} tag="button" onClick={handleNonPagabileChange} disabled={isButtonDisabled()}>
        Conferma
      </Button>
    </Container>
  )
}

export default SibaInputScadenzaValidita;